import React from 'react'
import { FeedDetailsView } from '@pushly/aqe/lib/components/feeds/feed-details-view'
import { useActiveDomainChangeEffect } from '@halo/hooks/use-active-domain-change-effect'
import aqe from '@pushly/aqe'

export const FeedDetailsViewWrapper = (props: any) => {
    const domainId = parseInt(props.match.params.domainId, 10)
    const feedId = parseInt(props.match.params.feedId, 10)

    const handleFeedClick = (notificationId: number) => {
        window.open(
            `${aqe.defaults.publicPlatformDomain}/domains/${domainId}/notifications/${notificationId}/summary`,
            '_blank',
            'noopener,noreferrer',
        )

        return false
    }

    useActiveDomainChangeEffect((activeDomain, appService) => {
        appService.route('/feeds')
    })

    return <FeedDetailsView domainId={domainId} feedId={feedId} handleFeedClick={handleFeedClick} />
}
